import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'recompose';
import { Container, Menu } from 'semantic-ui-react';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasRESTClient from '../../hocs/has-rest-client';
import hasOrgansation from '../../hocs/has-organisation';

import CampaignHeader from './campaign-header';
import InfluencersTab from './influencers-tab';
import ReportsDropdown from './reports-dropdown';

const PAGE_SIZE = 50;
const JUMBO_TYPE = 'JUMBO';

// Page lives in the URL (1-based) so it can be shared; internally we use 0-based.
const pageFromProps = props => {
  const raw = parseInt(_.get(props, 'location.query.page', '1'), 10);
  return Number.isNaN(raw) || raw < 1 ? 0 : raw - 1;
};

class LargeCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: {},
      discussions: [],
      total: null,
      isLoading: true,
      hasFailed: false,
      sort: '-lastScannedDate',
    };
  }

  componentDidMount() {
    this.loadCampaign();
    this.loadCount();
    this.loadPage(pageFromProps(this.props));
  }

  loadCount = () => {
    const { restClient, params: { id: campaignId } } = this.props;
    restClient.get(`/discussions?filter[campaign]=${campaignId}&page[limit]=1`)
      .then(res => this.setState({ total: _.get(res, 'data.meta.page.total', null) }))
      .catch(() => {});
  };

  componentWillReceiveProps(nextProps) {
    const nextPage = pageFromProps(nextProps);
    if (nextPage !== pageFromProps(this.props)) {
      this.loadPage(nextPage);
    }
  }

  onPageChange = page => {
    const { location } = this.props;
    this.context.router.push({
      pathname: location.pathname,
      query: { ...location.query, page: page + 1 },
    });
  };

  // Toggle last-scanned direction and reload the current page with the new order.
  onSortChange = () => {
    const sort = this.state.sort === '-lastScannedDate' ? 'lastScannedDate' : '-lastScannedDate';
    this.setState({ sort }, () => this.loadPage(pageFromProps(this.props)));
  };

  // Gate on the campaign type: only JUMBO campaigns belong on this page.
  // Access itself is enforced by the permission-scoped campaign fetch.
  loadCampaign = () => {
    const { jsonAPIClient, params: { id: campaignId } } = this.props;
    jsonAPIClient.get('campaigns', campaignId)
      .then(resource => {
        const campaign = resource.toJSONTree();
        if (campaign.campaignType !== JUMBO_TYPE) {
          this.context.router.replace('/');
          return;
        }
        this.setState({ campaign });
      })
      .catch(() => this.context.router.replace('/'));
  };

  loadPage = page => {
    const { jsonAPIClient, params: { id: campaignId } } = this.props;
    this.setState({ isLoading: true, hasFailed: false });

    jsonAPIClient.find('discussions', {
      filter: { campaign: campaignId },
      include: ['influencer', 'organisations.influencer'],
      sort: this.state.sort,
      page: { limit: PAGE_SIZE, offset: page * PAGE_SIZE },
    })
      .then(resources => {
        const discussions = resources.map(resource => resource.toJSONTree());
        this.setState({ discussions, isLoading: false });
      })
      .catch(() => this.setState({ discussions: [], isLoading: false, hasFailed: true }));
  };

  render() {
    const { campaign, discussions, total, isLoading, hasFailed, sort } = this.state;
    const { organisation } = this.props;

    return (
      <Container style={{ marginTop: '2rem' }}>
        <CampaignHeader campaign={campaign} />

        <Menu pointing secondary>
          <Menu.Item active>Influencers</Menu.Item>
          <Menu.Menu position="right">
            <ReportsDropdown campaign={campaign} organisation={organisation} />
          </Menu.Menu>
        </Menu>

        <InfluencersTab
          discussions={discussions}
          page={pageFromProps(this.props)}
          pageSize={PAGE_SIZE}
          total={total}
          isLoading={isLoading}
          hasFailed={hasFailed}
          onPageChange={this.onPageChange}
          sort={sort}
          onSortChange={this.onSortChange}
        />
      </Container>
    );
  }
}

LargeCampaign.contextTypes = {
  router: PropTypes.object.isRequired,
};

LargeCampaign.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string }).isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string, query: PropTypes.object }).isRequired,
  jsonAPIClient: PropTypes.shape({ find: PropTypes.func, get: PropTypes.func }).isRequired,
  restClient: PropTypes.shape({ get: PropTypes.func }).isRequired,
  organisation: PropTypes.object,
};

LargeCampaign.defaultProps = {
  organisation: {},
};

export default compose(hasJSONAPIClient, hasRESTClient, hasOrgansation)(LargeCampaign);



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/index.js
 **/